import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import RoleDesc from 'components/RoleDesc/RoleDesc';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});


function RolePopup({ open, handleClose, onChooseRole, role }) {
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
        >
            <DialogContent>
                <RoleDesc role={role?.role} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Anuller
                </Button>
                <Button onClick={onChooseRole} color="secondary">
                    Choisir ce rôle
                </Button>
            </DialogActions>
      </Dialog>
    );
}

export default RolePopup;